import { UserTypes } from '@/store/models/user';
import { useJwtStore } from '@/store/modules/jwt';

export function roleChecker(roles: UserTypes[]) {
  const jwtStore = useJwtStore();
  for (const role of roles) {
    if (jwtStore.UserDetail.customUser.role === role) {
      return true;
    }
  }
  return false;
}
export function isCurrentUser(userId: number | undefined) {
  if (userId === undefined) return false;
  if (useJwtStore().UserDetail.id === userId) {
    return true;
  }
  return false;
}

export function isSuperuser() {
  return useJwtStore().UserDetail.isSuperuser;
}

export async function WaitUntilRefreshed() {
  const jwtStore = useJwtStore();
  while (jwtStore.RefreshingToken) {
    await new Promise(resolve => setTimeout(resolve, 100));
  }
}

export function HasJwtExpired() {
  const exp = useJwtStore().DecodedPayload.exp;
  const now = Math.floor(new Date().getTime() / 1000);
  if (exp <= now) {
    return true;
  }
  return false;
}
